import React from 'react';

/* Design-provided magnifier for the palette's search trigger (kept
 * verbatim, stroke #6E7781 / 1.25). */
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchGlyph() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.9253 13.9267L11.0586 11.0601M12.0586 7.06006C12.0586 9.82148 9.82002 12.0601 7.05859 12.0601C4.29717 12.0601 2.05859 9.82148 2.05859 7.06006C2.05859 4.29863 4.29717 2.06006 7.05859 2.06006C9.82002 2.06006 12.0586 4.29863 12.0586 7.06006Z",
      stroke: "#6E7781",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}